import React, { useEffect, useState } from "react";
import ChatDetails from "./ChatComponent/ChatDetails";
import LoadCSSforfirstTime from "../../../CloudStorage/LoadCSSforfirstTime";
import ChatUserList from "./ChatComponent/ChatUserList";

export default function ChatFunctionality() {
  const path = "Assets/scss/chat.module.scss";
  const [selectUser, setselectUser] = useState(null);

  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  return (
    <div className="col-md-12 chat-box">
      <div className="row m-0">
        <div className="col-lg-4 col-md-5 p-0">
          <ChatUserList selectUser={selectUser} setselectUser={setselectUser} />
        </div>
        <div className="col-lg-8 col-md-7 p-0">
          <ChatDetails selectUser={selectUser} setselectUser={setselectUser} />
        </div>
      </div>
    </div>
  );
}
